const initialiseProductPage = () => {
  return new Promise((resolve) => {
    // Duplication of BodyClassName.CatalogProductView
    // Avoiding importing until we check the class
    if (document.body.classList.contains("catalog-product-view")) {
      import("./ProductPage").then((importedModule) => {
        const ProductPage = importedModule.default;
        const productPage = (GC.productPage = ProductPage.getInstance());
        productPage.initialise().then(() => {
          resolve();
        });
      });
    }
  });
};

export { initialiseProductPage };
